import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { title } from '@softline/application';
import { StempelApiRepository } from '../repositories/stempel-api.repository';
import { StempelIndexedDbRepository } from '../repositories/stempel-indexed-db.repository';
import { StempelService } from '../services/stempel.service';

@Component({
  selector: 'soft-stempel-terminal',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './stempel-terminal.component.html',
  styleUrls: ['./stempel-terminal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StempelService, StempelApiRepository, StempelIndexedDbRepository],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-50%)' }),
        animate(
          '250ms 50ms cubic-bezier(.46,.34,.6,1.09)',
          style({ opacity: 1, transform: '*' })
        ),
      ]),
      transition(':leave', [
        animate('180ms ease-in', style({ opacity: 0, transform: 'translateY(-50%)' })),
      ]),
    ]),
  ],
})
export default class StempelTerminalComponent {
  public readonly stempelService = inject(StempelService);
  constructor() {
    title('Stempel-Terminal');
  }
}
